//* Libraries imports
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

//* Config imports
import { API_URL, getAuthHeaders } from "@/config/api";

//* Utils imports
import { QUERY_KEYS, queryInvalidator } from "@/utils/query-client";

async function deleteSale(id: string) {
  const response = await fetch(`${API_URL}/sales/${id}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Falha ao excluir venda");
  }

  return true;
}

export function useDeleteSale() {
  return useMutation({
    mutationFn: deleteSale,
    onSuccess: async () => {
      await queryInvalidator([[QUERY_KEYS.SALES.ALL]]);
      toast.success("Venda excluída com sucesso!");
    },
  });
}
